export const ModalMixin = {
    props: {
        value: {
            required: true,
        }
    },
    data() {
        return {
            showModal: false,
            preloader: false
        }
    },
    created() {
        this.showModal = this.value;
    },
    watch: {
        showModal: function (value) {
            if (!value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        beforeSubmit() {
            this.preloader = true;
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        afterFinalResponse() {
            this.preloader = false;
            this.closeModal();
        }
    }
};